import { connect, ConnectedProps } from 'react-redux';

import lang from '../../../../lib/language';
import { RootState } from '../../../../lib/store';
import { getCurrentBuyingPower } from '../../../../lib/store/selectors';
import { formatCurrency } from '../../../../lib/util/DataHelpers';

import { useIsMobile } from '../../../../hooks';

import styles from './PnlContainer.module.scss';

const PnlContainer = (props: ReduxProps) => {
  const {
    accountStatusData,
    buyingPow,
  } = props;

  const { isMobile } = useIsMobile();

  const unrealizedPnl = accountStatusData.totalUnrealizedPnl;

  const totalPnl = accountStatusData.totalRealizedPnl + unrealizedPnl;

  const container = (key: string, value: string) => (
    <div className={styles.container}>
      <div className={styles.key}>
        {key}
      </div>
      <div className={styles.value}>
        {value}
      </div>
    </div>
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        {lang.performance()}
      </div>
      {isMobile ? (
        <div className={styles.content}>
          <div className={styles.contentMobile}>
            {container(lang.realizedPnl(), formatCurrency(accountStatusData.totalRealizedPnl))}
            {container(lang.unrealizedPnlHeader(), formatCurrency(unrealizedPnl))}
          </div>
          <div className={styles.contentMobile}>
            {container(lang.totalPnl(), formatCurrency(totalPnl))}
            {container(lang.availableBp(), formatCurrency(buyingPow))}
          </div>
        </div>
      ) : (
        <div className={styles.content}>
          {container(lang.availableBp(), formatCurrency(buyingPow))}
          {container(lang.realizedPnl(), formatCurrency(accountStatusData.totalRealizedPnl))}
          {container(lang.unrealizedPnlHeader(), formatCurrency(unrealizedPnl))}
          {container(lang.totalPnl(), formatCurrency(totalPnl))}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  buyingPow: getCurrentBuyingPower(state),
  accountStatusData: state.closeout.accountStatusData,
});
const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(PnlContainer);
